import Vue from 'vue'
import VueRouter from 'vue-router'
import { poolIdsWithAliases, poolIdsWithAliasesAndRouteOverrides } from '@/constants/pools'
const PoolApp = () => import('../components/PoolApp.vue')
const FactoryPoolApp = () => import('../components/FactoryPoolApp.vue')
const FactoryV2PoolApp = () => import('../components/FactoryV2PoolApp.vue')
const FactoryCryptoPoolApp = () => import('../components/FactoryCryptoPoolApp.vue')
const SwapRouter = () => import('../components/swap/SwapRouter.vue')
const DepositRouter = () => import('../components/deposit/DepositRouter.vue')
const DepositRen = () => import('../components/ren/Deposit.vue')
const WithdrawRouter = () => import('../components/withdraw/WithdrawRouter.vue')
const WithdrawRen = () => import('../components/ren/Withdraw.vue')
const WithdrawOld = () => import('../components/WithdrawOld.vue')
const Stats = () => import('../components/Stats.vue')
const FAQ = () => import('../views/FAQ.vue')
const ProfitRouter = () => import('../components/ProfitRouter.vue')
const RootApp = () => import('../components/root/RootApp.vue')
const Root = () => import('../components/root/Root.vue')
const CombinedStats = () => import('../components/root/CombinedStats.vue')
const ChartGraph = () => import('../components/graphs/Chart.vue')
const BasicTrade = () => import('../components/graphs/BasicTrade.vue')
const RootFAQ = () => import('../components/root/RootFAQ.vue')
const Audits = () => import('../views/Audits.vue')
const Pools = () => import('../views/Pools.vue')
const FactoryPools = () => import('../views/FactoryPools.vue')
const Whitepaper = () => import('../views/Whitepaper.vue')
const Contracts = () => import('../views/Contracts.vue')
const CurvePay = () => import('../components/CurvePay.vue')
const Events = () => import('../components/Events.vue')
const EstimateGas = () => import('../components/EstimateGas.vue')
const Integrations = () => import('../views/Integrations.vue')
const Risks = () => import('../views/Risks.vue')
const Careers = () => import('../views/Careers.vue')
const BugBounty = () => import('../views/BugBounty.vue')
const PoolRisks = () => import('../views/PoolRisks.vue')
const DeveloperDocs = () => import('../views/DeveloperDocs.vue')
const NotFound = () => import('../views/NotFound.vue')
const AddCRV = () => import('../views/AddCRV.vue')
const Recover = () => import('../views/Recover.vue')
const FactoryCreatePool = () => import('../views/FactoryCreatePool.vue')
const GaugeCreateVote = () => import('../views/GaugeCreateVote.vue')
const DeployGauge = () => import('../views/DeployGauge.vue')

const ycTokens = () => import('../components/ycTokens/Index.vue')

const Registry = () => import('../components/test/Registry.vue')

const Gateway = () => import('../components/ren/Gateway.vue')

const earlyCRV = () => import('../components/earlyCRV.vue')

const useCRV = () => import('../components/root/UseCRV.vue')

import init from '../init'
import { getters, contract as currentContract, setCurrencies, changeContract } from '../contract'
import * as common from '../utils/common.js'
import pools from '@/constants/pools'

Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    name: 'Root',
    component: RootApp,
    children: [
      {
        name: 'RootIndex',
        path: '',
        component: Root
      },
      {
        path: '/basictrade',
        name: 'BasicTrade',
        component: BasicTrade,
      },
      {
        path: '/exchange/:params(.*)?',
        name: 'Exchange',
        component: ChartGraph,
      },
      {
        path: '/trade/:params(.*)?',
        name: 'Trade',
        component: ChartGraph,
      },
      {
        name: 'CombinedStats',
        path: 'combinedstats',
        component: CombinedStats,
      },
      {
        name: 'Audits',
        path: 'audits',
        component: Audits,
      },
      {
        name: 'Pools',
        path: 'pools',
        component: Pools,
      },
      {
        name: 'FactoryPools',
        path: 'factory-v1',
        component: FactoryPools,
      },
      {
        path: 'whitepaper',
        name: 'Whitepaper',
        component: Whitepaper,
      },
      {
        name: 'RootFAQ',
        path: '/rootfaq',
        component: RootFAQ,
      },
      {
        name: 'Contracts',
        path: '/contracts',
        component: Contracts,
      },
      {
        path: 'curvepay/:pool?',
        name: 'CurvePay',
        component: CurvePay,
      },
      {
        path: 'events/:params(.*)?',
        name: 'Events',
        component: Events,
      },
      {
        path: 'yctokens',
        name: 'ycTokens',
        component: ycTokens,
      },
      {
        path: 'estimategas',
        name: 'EstimateGas',
        component: EstimateGas,
      },
      {
        path: 'registry',
        name: 'Registry',
        component: Registry,
      },
      {
        path: 'integrations',
        name: 'Integrations',
        component: Integrations,
      },
      {
        path: 'risks',
        name: 'Risks',
        component: Risks,
      },
      {
        path: 'careers',
        name: 'Careers',
        component: Careers,
      },
      {
        path: 'bugbounty',
        name: 'BugBounty',
        component: BugBounty,
      },
      {
        path: 'devdocs',
        name: 'DeveloperDocs',
        component: DeveloperDocs,
      },
      {
        path: 'addCRV',
        name: 'AddCRV',
        component: AddCRV,
      },
      {
        path: 'recover',
        name: 'Recover',
        component: Recover,
      },
      {
        path: 'earlyCRV',
        name: 'earlyCRV',
        component: earlyCRV,
      },
      {
        path: 'useCRV',
        name: 'useCRV',
        component: useCRV,
      },
    ]
  },
  {
    path: '/compound/withdraw_old',
    component: PoolApp,
    children: [
      {
        path: '',
        name: 'WithdrawOld',
        component: WithdrawOld
      },
    ]
  },
  {
    path: '/susd',
    name: 'Index',
    component: PoolApp,
    children: [
      {
        path: '',
        name: 'Withdraw',
        component: WithdrawRouter
      },
      {
        path: '*',
        name: 'Withdraw',
        component: WithdrawRouter
      }
    ]
  },
  {
    path: '/ren/gateway',
    component: PoolApp,
    children: [
      {
        path: '',
        name: 'Gateway',
        component: Gateway,
      }
    ],
  },
  {
    path: '/ren/depositren',
    component: PoolApp,
    children: [
      {
        path: '',
        name: 'DepositRen',
        component: DepositRen,
      }
    ],
  },
  {
    path: '/ren/withdrawren',
    component: PoolApp,
    children: [
      {
        path: '',
        name: 'WithdrawRen',
        component: WithdrawRen,
      }
    ],
  },
  {
    path: '/ren/native/:recover?',
    component: PoolApp,
    children: [
      {
        path: '',
        name: 'Swap',
        component: SwapRouter,
      }
    ]
  },
  {
    path: '/sbtc/native/:recover?',
    component: PoolApp,
    children: [
      {
        path: '',
        name: 'Swap',
        component: SwapRouter,
      }
    ]
  },
  {
    path: `/:pool(${poolIdsWithAliasesAndRouteOverrides.join('|')})/`,
    name: 'Index',
    component: PoolApp,
    children: [
      {
        path: '',
        name: 'Swap',
        component: SwapRouter,
      },
      {
        path: 'deposit',
        name: 'Deposit',
        component: DepositRouter
      },
      {
        path: 'withdraw',
        name: 'Withdraw',
        component: WithdrawRouter
      },
      {
        path: 'withdraw_old',
        name: 'WithdrawOld',
        beforeEnter: (to, from, next) => {
          if (to.params.pool == 'susd') return next()
          return next('/' + to.params.pool + '/withdraw')
        }
      },
      {
        path: 'stats',
        name: 'Stats',
        component: Stats
      },
      {
        path: 'faq',
        name: 'FAQ',
        component: FAQ
      },
      {
        path: 'profit/:address?',
        name: 'Profit',
        component: ProfitRouter
      },
      {
        path: 'audits',
        name: 'Audits',
        component: Audits,
      },
      {
        path: 'whitepaper',
        name: 'Whitepaper',
        component: Whitepaper,
      },
      {
        path: 'risks',
        name: 'PoolRisks',
        component: PoolRisks,
      },
    ]
  },
  {
    path: `/factory-v1/:poolId/`,
    name: 'Index',
    component: FactoryPoolApp,
    children: [
      {
        path: '',
        name: 'Swap',
        component: SwapRouter,
      },
      {
        path: 'deposit',
        name: 'Deposit',
        component: DepositRouter
      },
      {
        path: 'withdraw',
        name: 'Withdraw',
        component: WithdrawRouter
      },
      {
        path: 'audits',
        name: 'Audits',
        component: Audits,
      },
      {
        path: 'whitepaper',
        name: 'Whitepaper',
        component: Whitepaper,
      },
      {
        path: 'risks',
        name: 'PoolRisks',
        component: PoolRisks,
      },
    ]
  },
  {
    path: `/factory/create/`,
    name: 'Index',
    component: FactoryV2PoolApp,
    children: [
      {
        path: '',
        name: 'FactoryCreatePool',
        component: FactoryCreatePool,
      },
    ]
  },
  {
    path: `/factory/create_vote/`,
    name: 'Index',
    component: FactoryV2PoolApp,
    children: [
      {
        path: '',
        name: 'GaugeCreateVote',
        component: GaugeCreateVote,
      },
    ]
  },
  {
    path: `/factory/create_gauge/`,
    name: 'Index',
    component: FactoryV2PoolApp,
    children: [
      {
        path: '',
        name: 'DeployGauge',
        component: DeployGauge,
      },
    ]
  },
  {
    path: `/factory-crypto/:poolId/`,
    name: 'Index',
    component: FactoryCryptoPoolApp,
    children: [
      {
        path: '',
        name: 'Swap',
        component: SwapRouter,
      },
      {
        path: 'deposit',
        name: 'Deposit',
        component: DepositRouter
      },
      {
        path: 'withdraw',
        name: 'Withdraw',
        component: WithdrawRouter
      },
      {
        path: 'audits',
        name: 'Audits',
        component: Audits,
      },
      {
        path: 'whitepaper',
        name: 'Whitepaper',
        component: Whitepaper,
      },
      {
        path: 'risks',
        name: 'PoolRisks',
        component: PoolRisks,
      },
    ]
  },
  {
    path: `/factory/:poolId/`,
    name: 'Index',
    component: FactoryV2PoolApp,
    children: [
      {
        path: '',
        name: 'Swap',
        component: SwapRouter,
      },
      {
        path: 'deposit',
        name: 'Deposit',
        component: DepositRouter
      },
      {
        path: 'withdraw',
        name: 'Withdraw',
        component: WithdrawRouter
      },
      {
        path: 'audits',
        name: 'Audits',
        component: Audits,
      },
      {
        path: 'whitepaper',
        name: 'Whitepaper',
        component: Whitepaper,
      },
      {
        path: 'risks',
        name: 'PoolRisks',
        component: PoolRisks,
      },
    ]
  },
  {
    path: '*',
    name: 'NotFound',
    component: RootApp,
    children: [
      {
        path: '',
        name: 'NotFound',
        component: NotFound,
      },
    ]
    //redirect: '/'
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if (from.path.includes('/compound/withdraw_old')) await common.update_fee_info()
  //if(from.path.includes('profit') && to.path.includes('profit')) return window.location.href = to.path
  if (['Donate', 'Audits'].includes(to.name)) return next();
  if (to.name == 'RootIndex') {
    init(pools[0].id);
    return next();
  }
  let subdomain;
  const pathParts = to.path.split('/');
  const pathPoolName = pathParts[1].toLowerCase();
  if (pathPoolName === 'factory-v1') subdomain = `factory-${pathParts[2]}`; // e.g. /factory-v1/88 -> 'factory-88'
  else if (pathPoolName === 'factory') subdomain = `factory-v2-${pathParts[2]}`; // e.g. /factory/88 -> 'factory-v2-88'
  else if (pathPoolName === 'factory-crypto') subdomain = `factory-crypto-${pathParts[2]}`; // e.g. /factory-crypto/88 -> 'factory-crypto-88'
  else if (poolIdsWithAliases.includes(pathPoolName)) subdomain = pathPoolName;
  else if (poolIdsWithAliasesAndRouteOverrides.includes(pathPoolName)) subdomain = pools.find(({ routeOverride }) => routeOverride === pathPoolName).id;
  else subdomain = window.location.hostname.split('.')[0]
  /*  if(window.location.hostname.split('.').length > 1) subdomain = window.location.hostname.split('.')[0]
    else subdomain = to.path.split('/')[1]*/
  if (subdomain == 'y') subdomain = 'iearn'
  const isFirstPageLoad = from.name === null;
  if (!poolIdsWithAliases.includes(subdomain) && (!subdomain.startsWith('factory-') || isFirstPageLoad)) subdomain = pools[0].id

  if (!['ren', 'sbtc'].includes(subdomain)) {
    currentContract.swapbtc = false
  }
  if ((currentContract.currentContract != subdomain && !['Stats', 'FAQ', 'Donate'].includes(to.name) && to.path !== '/pools' && to.path !== '/factory-v1' && to.path !== '/factory' && to.path !== '/factory-crypto') || ['Stats', 'FAQ', 'Donate'].includes(from.name)) {
    changeContract(subdomain)
    currentContract.currentContract = subdomain
    next();
  }
  else if (!['Stats', 'FAQ', 'Donate'].includes(to.name)) {
    next();
    if (!currentContract.initializedContracts) {
      let inits = [init(subdomain)]
      if (['gusd', 'husd', 'usdk', 'usdn', 'linkusd', 'musd', 'rsv', 'dusd', 'ust', 'usdp'].includes(subdomain))
        inits.push(init('3pool'))
      if (['tbtc', 'pbtc', 'bbtc', 'obtc'].includes(subdomain))
        inits.push(init('sbtc'))
      await Promise.all(inits);
    }
  }
  else {
    console.log('B')
    currentContract.currentContract = subdomain;
    return next();
  }
})

router.afterEach(async (to, from, next) => {

})

export default router
